import React from 'react';
import DesignDetailsSidebar from 'contest/apps/design-details/components/design-details-sidebar';
import DesignCanvasOverlay from 'contest/apps/design-details/components/design-canvas-overlay';

export default function renderDdo(DdoComponent, designId, urls, activeUser, ownerUserId) {
    return (
        <DdoComponent
            designId={designId}
            headerSeeMoreDesignsUrl={urls.designs}
            renderSidebar={(sidebarProps) => {
                const recipientUser =
                    activeUser && activeUser.userId !== ownerUserId
                        ? { userId: ownerUserId }
                        : sidebarProps.design.creator;

                return (
                    <DesignDetailsSidebar
                        urls={urls}
                        activeUser={activeUser}
                        recipientUser={recipientUser}
                        {...sidebarProps}
                    />
                );
            }}
            renderDesignCanvasOverlay={({ design }) => <DesignCanvasOverlay design={design} />}
        />
    );
}



// WEBPACK FOOTER //
// ./src/web/js/contest/renderDdo.jsx